// Zentrale Versionsnummer aus .env Datei
// Diese Datei wird vom Build-Script generiert oder manuell aktualisiert

// WICHTIG: Diese Datei wird automatisch generiert basierend auf der .env Datei im Root
// Bitte die Versionsnummer NICHT hier direkt ändern, sondern in der .env Datei im Root-Verzeichnis

// Fallback-Version (wird verwendet, falls .env nicht verfügbar ist)
let APP_VERSION = '1.2.7';

// Versuche Version aus verschiedenen Quellen zu laden:
// 1. Aus app.json (wird zur Build-Zeit gesetzt)
try {
  if (typeof require !== 'undefined') {
    const appJson = require('../../app.json');
    APP_VERSION = appJson?.expo?.version || APP_VERSION;
  }
} catch (error) {
  // Ignoriere Fehler beim Laden von app.json
}

// Exportiere die Versionsnummer
export default APP_VERSION;
export const getAppVersion = () => APP_VERSION;

